import Vue from 'vue'
import { path } from './helpers'

const client = Vue.prototype.$api

export default {
  getFiles (fileId = null) {
    return client.get(path('files', fileId))
  },
  getFilesTags (isApp = false) {
    return client.get('fileTags', { params: { isApp: isApp } })
  },
  getImage (fileId) {
    return client.get('files/downloadImage', { params: { id: fileId } })
  },
  markLinkAsReaded (linkId) {
    return client.get('files/markLinkAsReaded', { params: { linkId: linkId } })
  }
}



// WEBPACK FOOTER //
// ./src/repositories/FilesRepository.js